import { render, staticRenderFns } from "./TariffRateList.vue?vue&type=template&id=4521899e&"
import script from "./TariffRateList.vue?vue&type=script&lang=js&"
export * from "./TariffRateList.vue?vue&type=script&lang=js&"
import style0 from "./TariffRateList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TariffRateList.vue"
export default component.exports